import { render } from "./Designation.vue?vue&type=template&id=43b9f9e8"
import script from "./Designation.vue?vue&type=script&lang=js"
export * from "./Designation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__